module.exports = __webpack_public_path__ + "static/450016927.6f4c5fee.jpg";